import PropTypes from "prop-types"

export const SWAP = PropTypes.shape({
  ticker: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  terminationDate: PropTypes.string,
})
